import type { ComponentProps } from 'react'

import { useFieldDescribedBy } from '@/components/sui/field'
import { Checkbox as UiCheckbox } from '@/components/ui/checkbox'
import { cn } from '@/lib/utils'

const INDETERMINATE =
  'data-indeterminate:bg-primary dark:data-indeterminate:bg-primary data-indeterminate:border-primary data-indeterminate:text-primary-foreground data-indeterminate:[&_svg]:hidden data-indeterminate:before:absolute data-indeterminate:before:h-0.5 data-indeterminate:before:w-2 data-indeterminate:before:rounded-full data-indeterminate:before:bg-current'

export function Checkbox({
  className,
  'aria-describedby': ariaDescribedBy,
  ...props
}: ComponentProps<typeof UiCheckbox>) {
  const describedBy = useFieldDescribedBy(ariaDescribedBy)
  return (
    <UiCheckbox
      aria-describedby={describedBy}
      className={cn(
        'cursor-pointer data-disabled:cursor-not-allowed data-disabled:opacity-50',
        INDETERMINATE,
        className,
      )}
      {...props}
    />
  )
}
